import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';


import Logo from '../../../Assets/--WhiteBluePNG-TM.png';

const menuItems = [
  {
    className: 'auth_header_link',
    href: 'https://focusloop.io/',
    title: 'Home',
  },
  {
    className: 'auth_header_link',
    href: 'https://focusloop.io/features',
    title: 'Features',
  },
  {
    className: 'auth_header_link',
    href: 'https://focusloop.io/businesses',
    title: 'Small Business',
  },
  {
    className: 'auth_header_link',
    href: 'https://focusloop.io/startups',
    title: 'Startups',
  },
  {
    className: 'auth_header_link',
    href: 'https://focusloop.io/agencies',
    title: 'Agencies',
  },
  {
    className: 'auth_header_link',
    href: 'https://focusloop.io/pricing',
    title: 'Pricing',
  },
  {
    className: 'auth_header_link demo',
    href: 'https://focusloop.io/demo',
    title: `Let's Talk`,
  },
  {
    className: 'auth_header_link sign_in',
    href: '/auth/signin',
    title: 'Sign in',
  },
]

export default () => (
  <div className="auth_header">
    <img src={Logo} alt="logo" width={253} />
    <Typography variant='h5'>
      {menuItems.map((item, idx) => {
        const pathname = window.location.pathname;
        const className = `${item.className}${pathname === 'item.href' ? ' active' : ''}`
        return (
          <Link {...item} className={className} key={`menu_${idx}`}>{item.title}</Link>
        )
      })}
    </Typography>
  </div>
)
